import { useState } from "react";
import { flames } from "@/mocks/home";

const colorMap: Record<string, { dot: string; soft: string; text: string }> = {
  primary: { dot: "bg-primary-500", soft: "bg-primary-100", text: "text-primary-800" },
  accent: { dot: "bg-accent-500", soft: "bg-accent-100", text: "text-accent-800" },
  secondary: { dot: "bg-secondary-500", soft: "bg-secondary-100", text: "text-secondary-900" },
};

export default function FlamesSection() {
  const [active, setActive] = useState(0);
  const current = flames[active];
  const tone = colorMap[current.color] || colorMap.primary;

  return (
    <section id="flames" className="section-anchor w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="reveal max-w-2xl">
          <span className="text-xs font-label tracking-[0.2em] text-accent-600">死气之炎 / FLAME SYSTEM</span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl text-foreground-950">
            七种属性，构成作品的战斗骨架
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            死气之炎是作品后期最核心的战斗设定，不同属性各有特性，也代表了守护者们的性格与战斗风格。
            点击左侧属性，查看它代表的含义与在战斗中的作用。
          </p>
        </div>

        <div className="reveal mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1 flex flex-wrap lg:flex-col gap-2">
            {flames.map((f, idx) => {
              const c = colorMap[f.color] || colorMap.primary;
              const isActive = idx === active;
              return (
                <button
                  key={f.name}
                  type="button"
                  onClick={() => setActive(idx)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors border whitespace-nowrap ${
                    isActive
                      ? "bg-background-50 border-primary-300"
                      : "bg-transparent border-transparent hover:bg-background-50/70"
                  }`}
                >
                  <span className={`w-3.5 h-3.5 rounded-full ${c.dot}`} />
                  <span className="font-heading text-base text-foreground-950">{f.name}之炎</span>
                  <span className="ml-auto text-xs text-foreground-500 hidden lg:inline">{f.meaning}</span>
                </button>
              );
            })}
          </div>

          <div className="lg:col-span-2 rounded-lg bg-background-50 border border-background-200 overflow-hidden">
            <div className="w-full h-[200px] md:h-[240px]">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20flowing%20flames%20of%20amber%20orange%20and%20deep%20crimson%20swirling%20against%20a%20dark%20warm%20background%2C%20energetic%20stylized%20illustration%2C%20glowing%20ember%20particles%2C%20dramatic%20lighting%2C%20high%20contrast%20texture&width=1400&height=600&seq=flame-attribute-2026&orientation=landscape"
                alt="抽象的暖色火焰与光粒交错的装饰插画"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 md:p-7">
              <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${tone.soft} ${tone.text}`}>
                <span className={`w-2 h-2 rounded-full ${tone.dot}`} />
                <span className="text-xs md:text-sm font-label">{current.name}之炎</span>
              </div>
              <h3 className="mt-4 font-heading text-2xl text-foreground-950">
                象征：{current.meaning}
              </h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{current.desc}</p>
              <div className="mt-5 pt-5 border-t border-background-200 grid grid-cols-2 sm:grid-cols-3 gap-3 text-xs text-foreground-600">
                <div>
                  <p className="text-foreground-400">属性序号</p>
                  <p className="mt-1 text-sm text-foreground-900">{String(active + 1).padStart(2, "0")} / 07</p>
                </div>
                <div>
                  <p className="text-foreground-400">核心概念</p>
                  <p className="mt-1 text-sm text-foreground-900">{current.meaning}</p>
                </div>
                <div>
                  <p className="text-foreground-400">关联设定</p>
                  <p className="mt-1 text-sm text-foreground-900">彭格列指环</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}